import React, { Fragment, useContext } from "react";
import styled, { ThemeContext } from "styled-components";
import { CardType, Text, Box, Stack, util } from "@thecb/components";
import { fallbackValues } from "./FormattedCreditCard.theme";

const { themeComponent } = util.theme;
const { renderCardStatus } = util.formats;

export const CreditCardWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const CCIconWrapper = styled.div`
  margin-right: 8px;
  width: 36px;
  height: auto;
  display: flex;
`;

const FormattedCreditCard = ({
  lastFour,
  type,
  autoPay,
  expireDate,
  expirationStatus,
  themeValues
}) => {
  const { isMobile } = useContext(ThemeContext);
  return (
    <CreditCardWrapper>
      <CCIconWrapper>
        <CardType type={type} size={isMobile ? "small" : "large"} />
      </CCIconWrapper>
      <Stack childGap="0">
        <Box padding="0">
          <Text
            variant="p"
            padding="0"
            color={themeValues.textColor}
            textAlign="left"
            extraStyles={`display: inline-block;`}
          >
            {`Card ending in ${lastFour}`}
          </Text>
          {expireDate && (
            <Fragment>
              {renderCardStatus(expirationStatus, expireDate, "left", "p")}
            </Fragment>
          )}
        </Box>
        {autoPay && (
          <Text
            variant="p"
            color={themeValues.autopayTextColor}
            extraStyles={`font-style: italic; font-size: .75rem;`}
          >{`Autopay On`}</Text>
        )}
      </Stack>
    </CreditCardWrapper>
  );
};
export default themeComponent(
  FormattedCreditCard,
  "FormattedCreditCard",
  fallbackValues
);
